export const ADD_BULK_LIST = "ADD_BULK_LIST";
export const ADD_MULTIPLE_TRANSFERS_LIST = "ADD_MULTIPLE_TRANSFERS_LIST";
export const SELECTED_BANK_DATA_BULK = "SELECTED_BANK_DATA_BULK";
export const VIEW_SEND_MONEY_ACCOUNT = "VIEW_SEND_MONEY_ACCOUNT";
export const HIDE_SEND_MONEY_ACCOUNT = "HIDE_SEND_MONEY_ACCOUNT";
export const VERIFY_ACCOUNT_STARTED = "VERIFY_ACCOUNT_STARTED";
export const VERIFY_ACCOUNT_SUCCEDEED = "VERIFY_ACCOUNT_SUCCEDEED";
export const VERIFY_ACCOUNT_FAILED = "VERIFY_ACCOUNT_FAILED";
export const RESET_PAYMENTS = "RESET_PAYMENTS";
export const SET_BENEFICIARY_DATA = "SET_BENEFICIARY_DATA";
export const SET_BULK_PAYMENT_TYPE = "SET_BULK_PAYMENT_TYPE";
export const MAKE_BULK_PAYMENT_STARTED = "MAKE_BULK_PAYMENT_STARTED";
export const MAKE_BULK_PAYMENT_SUCCEDED = "MAKE_BULK_PAYMENT_SUCCEDED";
export const MAKE_BULK_PAYMENT_FAILED = "MAKE_BULK_PAYMENT_FAILED";
export const ADD_MULTIPLE_TRANSFER_NOTE = "ADD_MULTIPLE_TRANSFER_NOTE";
export const SKIP_MULTIPLE_TRANSFER_NOTE = "SKIP_MULTIPLE_TRANSFER_NOTE";
export const BULK_PAYMENT_NAME_INQUIRY_STARTED =
  "BULK_PAYMENT_NAME_INQUIRY_STARTED";
export const BULK_PAYMENT_NAME_INQUIRY_SUCCEDED =
  "BULK_PAYMENT_NAME_INQUIRY_SUCCEDED";
export const BULK_PAYMENT_NAME_INQUIRY_FAILED =
  "BULK_PAYMENT_NAME_INQUIRY_FAILED";
export const EDIT_SINGLE_MULTIPLE_TRANSFER = "EDIT_SINGLE_MULTIPLE_TRANSFER";
export const DELETE_SINGLE_MULTIPLE_TRANSFER =
  "DELETE_SINGLE_MULTIPLE_TRANSFER";
export const ON_EDIT_MULTIPLE_TRANSFER_ITEM = "ON_EDIT_MULTIPLE_TRANSFER_ITEM";
export const RESET_TRANSFER_LIST = "RESET_TRANSFER_LIST";
export const RESET_UPLOAD_CSV_LIST = "RESET_UPLOAD_CSV_LIST";
export const RESET_BENEFICIARY_STATE = "RESET_BENEFICIARY_STATE";
export const PROCESS_BULK_TRANSFER_STARTED = "PROCESS_BULK_TRANSFER_STARTED";
export const PROCESS_BULK_TRANSFER_SUCCEDED = "PROCESS_BULK_TRANSFER_SUCCEDED";
export const PROCESS_BULK_TRANSFER_FAILED = "PROCESS_BULK_TRANSFER_FAILED";
export const SINGLE_BULK_PAYMENT_NAME_INQUIRY_STARTED =
  "SINGLE_BULK_PAYMENT_NAME_INQUIRY_STARTED";
export const SINGLE_BULK_PAYMENT_NAME_INQUIRY_SUCCEDED =
  "SINGLE_BULK_PAYMENT_NAME_INQUIRY_SUCCEDED";
export const SINGLE_BULK_PAYMENT_NAME_INQUIRY_FAILED =
  "SINGLE_BULK_PAYMENT_NAME_INQUIRY_FAILED";
export const UPDATE_NAME_INQUIRY_LIST = "UPDATE_NAME_INQUIRY_LIST"
export const DELETE_BULK_PAYMENT_ITEM = "DELETE_BULK_PAYMENT_ITEM"

